module.exports = __webpack_public_path__ + "static/media/cimg2.55a7230b.jpg";